export default __webpack_public_path__ + "static/media/check0.0fb3fe94.svg";